module.exports = __webpack_public_path__ + "img/0.01387d54.png";